import { VehicleInfo } from '../models/vehicle-info';
import { InfocarVeicolo } from './infocar-veicolo';

export class InfocarDaTarga {
  dataimmatricolazione: Date;
  telaio: string;
  immatricolazioneEstera: string;
  periodoImmatricolazione: string;
  lista: InfocarVeicolo [];


  static InfocarDaTargaToVehicleInfoDto(infocarDaTarga: InfocarDaTarga, vehiclePlate: string): VehicleInfo {
    let result = new VehicleInfo();
    result.vehiclePlate = vehiclePlate;
    result.registrationDate = infocarDaTarga.dataimmatricolazione;
    result.chassisCode = infocarDaTarga.telaio;
    result.foreignPlate = infocarDaTarga.immatricolazioneEstera == "N"? false : true;
    result.registrationPeriod = infocarDaTarga.periodoImmatricolazione;

    if (infocarDaTarga.lista && infocarDaTarga.lista.length) {
      result.versions = infocarDaTarga.lista.map(_ => InfocarVeicolo.infocarVeicoloToVehicleVersionDto(_));
    }
    return result;
  }

}
